import React from 'react';
import MainLayout from './pages/Menu/MainLayout';



function App() {
  return <MainLayout />;
}

export default App;
